
import { CampaignFormData } from '../types';

export const validateFormDataForSerialization = (formData: CampaignFormData): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  try {
    // Test if the entire form data can be serialized
    JSON.stringify(formData);
    
    // Check for common problematic objects
    const checkForProblematicObjects = (obj: any, path: string = '') => {
      if (obj === null || obj === undefined) return;
      
      if (typeof obj === 'object') {
        // Check for DOM objects, File objects, etc.
        if (obj instanceof File || 
            obj instanceof Blob || 
            obj instanceof Event ||
            obj instanceof Element ||
            obj instanceof Node ||
            obj instanceof Promise ||
            obj instanceof MessageEvent ||
            obj instanceof Map ||
            obj instanceof Set ||
            obj instanceof WeakMap ||
            obj instanceof WeakSet ||
            obj?.constructor?.name === 'File' ||
            obj?.constructor?.name === 'Event' ||
            obj?.constructor?.name === 'Promise' ||
            obj?.constructor?.name === 'MessageEvent' ||
            obj?.tagName !== undefined ||
            obj?.nodeType !== undefined ||
            obj?.preventDefault !== undefined ||
            obj?.then !== undefined) {
          errors.push(`Found non-serializable object at ${path}: ${obj?.constructor?.name || typeof obj}`);
          return;
        }
        
        // Recursively check nested objects
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            checkForProblematicObjects(obj[key], path ? `${path}.${key}` : key);
          }
        }
      }
    };
    
    checkForProblematicObjects(formData);
    
    // Specifically check uploaded documents
    if (formData.documents_and_links?.uploaded_documents) {
      formData.documents_and_links.uploaded_documents.forEach((doc, index) => {
        if (!doc.id || typeof doc.id !== 'string') {
          errors.push(`Document ${index} missing or invalid id`);
        }
        if (!doc.name || typeof doc.name !== 'string') {
          errors.push(`Document ${index} missing or invalid name`);
        }
        if (typeof doc.content !== 'string') {
          errors.push(`Document ${index} has invalid content type`);
        }
      });
    }
    
  } catch (error) {
    errors.push(`Validation error: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const cleanFormDataForSerialization = (formData: CampaignFormData): CampaignFormData => {
  try {
    // Simple deep clone using JSON methods
    return JSON.parse(JSON.stringify(formData));
  } catch (error) {
    console.error('Error cleaning form data:', error);
    throw new Error('Failed to clean form data for serialization');
  }
};
